import type { PathwayUserReport } from '@cfa/pathway-fe-shared/xp';

import { processUserName } from '@/services/modelHelper';

export type PlanAssigneeNameSource = Partial<
  Pick<PathwayUserReport, 'firstName' | 'lastName' | 'name' | 'prefName'>
>;

export const teamMemberNamesFromUser = (user?: PlanAssigneeNameSource) => ({
  name: processUserName(user),
  displayName: processUserName({
    prefName: user?.prefName,
    firstName: user?.firstName,
    lastName: user?.lastName,
  }),
});

export const percentCompleteFromSteps = (
  completedSteps: number,
  totalSteps: number,
) => (totalSteps ? Math.round((completedSteps / totalSteps) * 100) : 0);
